import RemindReceiv from "../page/Remind/Receiv";

import CustomerList from "../page/Customer/List";

import HouseMaintain from "../page/House/Maintain";
import HouseBuilding from "../page/House/Building";
import HouseLease from "../page/House/Lease";

import OperateHouseMaintain from "../page/OperateHouse/Maintain";

import OperateHouseDevice from "../page/OperateDevice/HouseDevice";

import OperateRepairReport from "../page/DeviceRepairReport/RepairReport";

import DeviceBill from "../page/DeviceBill/index";

import DeviceBillWriteOff from "../page/DeviceBillWriteOff/index";

import RentContractList from "../page/RentContract/List";
import ExpireRentContractList from "../page/RentContract/expireList";
import RentContractTemplate from "../page/RentContract/Template";
import RentContractProject from "../page/RentContract/Project";
import AcceptsHousingContract from "../page/RentContract/AcceptsHousingContract"
import RentContractReview from "../page/RentContract/review";

import BillReceiv from "../page/Bill/Receiv";
import BillPayment from "../page/Bill/Payment";

import BillPrintReceipt from "../page/Bill/PrintReceipt/Receipt";

import PaymentDetailed from "../page/Payment/Detailed";
import PaymentTransfer from "../page/Payment/Transfer";
import PaymentAccountingRecord from "../page/AccountingRecord/inedx";


import CouponList from "../page/Coupons/List"
import CouponLogList from "../page/Coupons/log/List"

import wftPayChannelList from "../page/WftPayChannel/List"

import wftPayClrgRuleList from "../page/WftPayClrgRule/List"

import hsjPayChannelList from "../page/HsbPayChannel/List"

import hsbPayClrgRuleList from "../page/HsbPayClrgRule/List"



import EmployeeManage from "../page/Employee/Manage";
import EmployeeRole from "../page/Employee/Role";
import EmployeeDepartment from "../page/Employee/Department";
import EmployeeChannel from "../page/Employee/Channel";
import EmployeeChannelCustomer from "../page/Employee/ChannelCustomer";

import MerchantManage from "../page/Merchant/Manage";
import MerchantDepartment from "../page/Merchant/Department";
import MerchantUser from "../page/Merchant/User";
import MerchantRole from "../page/Merchant/Role";

import ReportPayment from "../page/Report/Payment";

import DeviceReportPayment from "../page/DeviceBillReport/Payment";

import HsbPaySplitAccountSum from "../page/HsbPaySplitAccountSum";

import ProjectMonitoringStatistics from "../page/ProjectMonitoringStatistics";

import OtherShort from "../page/Other/Short";
import OtherWarning from "../page/Other/WarningList";

import HouseTypeList from "../page/HouseType";
import DeviceHouseTypeList from "../page/DeviceHouseType";
import Salesroom from "../page/Salesroom";
import TransferRecordLog from "../page/TransferRecordLog";
import TransferRecordReminder from "../page/TransferRecordReminder";
import AccountingRecordReport from "../page/AccountingRecordReport";
import PlatformAccountingRecord from "../page/PlatformAccountingRecord";
import WeChatServices from "../page/CustomerServices/WeChatServices";
import CustomerChatList from "../page/CustomerServices/CustomerList";
import HouseKeep from "../page/HouseKeep";
import ZJBSyncDataRecord from "../page/ZJBSyncDataRecord";
import HsbMarketPlatformList from "../page/HsbMarketPlatform";
import HsbMarketPlatformMerchant from "../page/HsbMarketPlatform/merchant";
import RentCycle from "../page/RentCycle";
import Device from "../page/Device";


const routers = [
    // 首款提醒
    {
        path: '/admin/finance/receiv',
        exact: true,
        title: '提醒',
        component: RemindReceiv
    },
    // 用户
    {
        path: '/admin/customer/list',
        exact: true,
        title: '承租人',
        component: CustomerList
    },
    {
        path: '/admin/customer/housekeepList',
        exact: true,
        title: '管家列表',
        component: HouseKeep
    },
    // 房源
    {
        path: '/admin/house/maintain',
        exact: true,
        title: '房源维护',
        component: HouseMaintain
    },
    {
        path: '/admin/operate/operateMaintain',
        exact: true,
        title: '房源列表',
        component: OperateHouseMaintain
    },
    // 报表
    {
        path: '/admin/operate/payment',
        exact: true,
        title: '设备收款报表',
        component: DeviceReportPayment
    },
    {
        path: '/admin/operate/operateDevice',
        exact: true,
        title: '设备二维码',
        component: OperateHouseDevice
    },
    {
        path: '/admin/operate/repairReport',
        exact: true,
        title: '报修记录',
        component: OperateRepairReport
    },
    {
        path: '/admin/operate/deviceBill',
        exact: true,
        title: '设备账单',
        component: DeviceBill
    },
    {
        path: '/admin/operate/billWriteOff',
        exact: true,
        title: '账单核销',
        component: DeviceBillWriteOff
    },
    {
        path: '/admin/house/building',
        exact: true,
        title: '小区/楼栋维护',
        component: HouseBuilding
    },
    {
        path: '/admin/rentContract/lease',
        exact: true,
        title: '房源租赁',
        component: HouseLease
    },
    // 户型
    {
        path: '/admin/house/houseType',
        exact: true,
        title: '户型管理',
        component: HouseTypeList
    },
    {
        path: '/admin/house/deviceHouseType',
        exact: true,
        title: '设备户型管理',
        component: DeviceHouseTypeList
    },
    // 门店
    {
        path: '/admin/salesroom/list',
        exact: true,
        title: '门店管理',
        component: Salesroom
    },

    // 合同
    {
        path: '/admin/rentContract/list',
        exact: true,
        title: '租客合同',
        component: RentContractList
    },
    {
        path: '/admin/rentContract/expireList',
        exact: true,
        title: '租客合同到期提醒',
        component: ExpireRentContractList
    },
    {
        path: '/admin/rentContract/template',
        exact: true,
        title: '合同模板',
        component: RentContractTemplate
    },
    {
        path: '/admin/rentContract/review',
        exact: true,
        title: '合同审批',
        component: RentContractReview,
    },
    {
        path: '/admin/merchant/project',
        exact: true,
        title: '项目管理',
        component: RentContractProject
    },
    {
        path: '/admin/merchant/acceptsHousingContract',
        exact: true,
        title: '收房合同管理',
        component: AcceptsHousingContract
    },
    {
        path: '/admin/merchant/rentCycle',
        exact: true,
        title: '房租周期配置',
        component: RentCycle
    },
    {
        path: '/admin/merchant/device',
        exact: true,
        title: '设备管理',
        component: Device
    },
    // 账单
    {

        //path: '/admin/bill/receiv',
        path: '/admin/finance/billReceiv',
        exact: true,
        title: '收款账单',
        component: BillReceiv
    },
    {

        //path: '/admin/bill/receiv',
        path: '/admin/finance/printBillReceipt',
        exact: true,
        title: '收据打印',
        component: BillPrintReceipt
    },
    {
        path: '/admin/finance/billPayment',
        exact: true,
        title: '退款账单',
        component: BillPayment
    },
    {
        path: '/admin/finance/hsbMerchantSplitAccount',
        exact: true,
        title: '惠市宝商户分账',
        component: HsbPaySplitAccountSum
    },
    {
        path: '/admin/finance/projectMonitoringStatistics',
        exact: true,
        title: '项目监控统计',
        component: ProjectMonitoringStatistics
    },
    //
    // 支付
    {
        path: '/admin/finance/detailed',
        exact: true,
        title: '收款明细',
        component: PaymentDetailed
    },
    {
        path: '/admin/finance/transfer',
        exact: true,
        title: '项目转账',
        component: PaymentTransfer
    },
    {
        path: '/admin/finance/accountingRecord',
        exact: true,
        title: '商家对账',
        component: PaymentAccountingRecord
    },
    {
        path: '/admin/finance/transferRecord',
        exact: true,
        title: '银联划账管理',
        component: TransferRecordLog
    },
    {
        path: '/admin/finance/transferRecordReminder',
        exact: true,
        title: '银联划账提醒',
        component: TransferRecordReminder
    },
    {
        path: '/admin/finance/accountingRecordReport',
        exact: true,
        title: '对账报表',
        component: AccountingRecordReport
    },
    {
        path: '/admin/finance/platformAccountingRecord',
        exact: true,
        title: '平台对账',
        component: PlatformAccountingRecord
    },
    // 人员
    {
        path: '/admin/employee/manage',
        exact: true,
        title: '人员管理',
        component: EmployeeManage
    },
    {
        path: '/admin/employee/role',
        exact: true,
        title: '岗位管理',
        component: EmployeeRole
    },
    {
        path: '/admin/employee/department',
        exact: true,
        title: '部门管理',
        component: EmployeeDepartment
    },

    // 商户
    {
        path: '/admin/merchant/manage',
        exact: true,
        title: '商户管理',
        component: MerchantManage
    },
    {
        path: '/admin/merchant/department',
        exact: true,
        title: '管理部门',
        component: MerchantDepartment
    },
    {
        path: '/admin/merchant/user',
        exact: true,
        title: '人员管理',
        component: MerchantUser
    },
    {
        path: '/admin/merchant/coupon',
        exact: true,
        title: '优惠劵管理',
        component: CouponList
    },
    {
        path: '/admin/merchant/wftPayChannel',
        exact: true,
        title: '威富通支付渠道管理',
        component: wftPayChannelList
    },
    {
        path: '/admin/merchant/wftPayClrgRule',
        exact: true,
        title: '威富通分账配置管理',
        component: wftPayClrgRuleList
    },
    {
        path: '/admin/merchant/hsbPayChannel',
        exact: true,
        title: '惠市宝支付渠道管理',
        component: hsjPayChannelList
    },
    {
        path: '/admin/merchant/hsbPayClrgRule',
        exact: true,
        title: '惠市宝分账规则管理',
        component: hsbPayClrgRuleList
    },
    {
        path: '/admin/merchant/couponLog',
        exact: true,
        title: '优惠劵领取记录',
        component: CouponLogList
    },
    {
        path: '/admin/merchant/role',
        exact: true,
        title: '岗位管理',
        component: MerchantRole
    },
    {
        path: '/admin/merchant/hsbMarketSync',
        exact: true,
        title: '惠市宝市场同步信息',
        component: HsbMarketPlatformList,
    },
    // 报表
    {
        path: '/admin/finance/payment',
        exact: true,
        title: '收款报表',
        component: ReportPayment
    },
    {
        path: '/admin/channel/manage',
        exact: true,
        title: '渠道管理',
        component: EmployeeChannel
    },
    {
        path: '/admin/channel/customer',
        exact: true,
        title: '渠道管理',
        component: EmployeeChannelCustomer
    },
    // 客服
    {
        path: '/admin/customer/wechant-services',
        exact: true,
        title: '微信客服',
        component: WeChatServices
    },
    {
        path: '/admin/customer/customer-list',
        exact: true,
        title: '顾客列表',
        component: CustomerChatList,
    },
    // 其他
    {
        path: '/admin/other/short',
        exact: true,
        title: '短信发送明细',
        component: OtherShort
    },
    {
        path: '/admin/other/warningList',
        exact: true,
        title: '短信发送明细',
        component: OtherWarning
    },
    {
        path: '/admin/other/zjb-syncdata-record',
        exact: true,
        title: '租金宝同步数据报表',
        component: ZJBSyncDataRecord
    }


]
export default routers


// WEBPACK FOOTER //
// ./src/routes/routers.js